// extracted by mini-css-extract-plugin
export default {"content-theme__dark":"zs1CN"};